import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ResourcesService } from '../resources.service';
import { ConnectionService } from 'ng-connection-service';
import * as $ from "jquery/dist/jquery";
import * as M from "materialize-css/dist/js/materialize";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    @ViewChild('usuario') usuario;
    @ViewChild('contrasena') contrasena;

    alert_message: string;
    instance: any;
    isConnected = true;
    wifi = 'wifi';
    status = 'Conexión establecida';
    versionFE = '';
    versionBE = '';
    isChecked = false;
    platform = '';

    constructor(
        private http: HttpClient,
        public resource: ResourcesService,
        private connectionService: ConnectionService,
        private router: Router
    ) {
        this.versionFE = '6';
        this.versionamiento();
        let user = localStorage.getItem('user')
        if (user != undefined) {
            this.router.navigate(['/galpones/']);
            return
        }

        this.isChecked = localStorage.getItem('btnAgregarAves') == "true" ? true : false;

        this.platform = navigator.platform;

        this.connectionService.monitor().subscribe(isConnected => {
            this.isConnected = isConnected;
            if (this.isConnected) {
                this.status = 'Conexión establecida'
                this.wifi = 'wifi'
            }
            else {
                this.status = 'Sin internet'
                this.wifi = 'wifi_off'
            }
        })
    }

    ngOnInit(): void {
    }

    alert(texto) {
        this.alert_message = texto;
        var elem = document.querySelector('#modal_login');
        this.instance = M.Modal.init(elem);
        this.instance.open();
    }

    close() {
        this.instance.close();
    }

    versionamiento() {
        this.http.get(this.resource.routePlanta + '/usuario/versionBE/' + this.resource.versionModulo).subscribe(
            (data: any) => {
                this.versionBE = data.version;
            }
        );
    }

    login() {
        if (this.versionFE == this.versionBE) {
            if (this.usuario.nativeElement.value == '') return;
            if (this.contrasena.nativeElement.value == '') return;
            return this.http.post(this.resource.route + '/usuarios/signin/', {
                usuario: this.usuario.nativeElement.value,
                contrasena: this.contrasena.nativeElement.value
            }).subscribe(
                (data: any) => {
                    console.log('login', data)
                    if (data.length > 0) {
                        localStorage.setItem('user', JSON.stringify(data[0]));
                        this.router.navigate(['/galpones/']);
                    } else {
                        $('#usuario').val('')
                        $('#contrasena').val('')
                        $('#usuario').focus()
                        this.alert('El usuario no existe, intente de nuevo')
                    }
                }, error => {
                    this.alert('Hubo un error. Revise si tiene conexión a internet')
                    // if (this.resource.route == 'http://159.65.47.181:8081') {
                    //      localStorage.setItem('user', JSON.stringify({
                    //          IDUSUARIO: 12,
                    //          USUARIO: "admin",
                    //          USUARIONOM: "Administrador",
                    //          CLAVE: "5c6dd016bff4165cd0b44d72829aad4f",
                    //          EMAIL: "admin@correo.com",
                    //          FOTO: null
                    //      }));
                    //      this.router.navigate(['/galpones/']);
                    // }
                }
            );
        } else {
            this.alert('Es necesario actualizar el sistema')
            setTimeout(() => {
                location.reload();                
            }, 2000);
        }
    }

    checkValue(){
        localStorage.setItem('btnAgregarAves',this.isChecked.toString());
    }
}
